import LandingPage from './LandingPage';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import BlogPage from './BlogPage';
import BlogSinglePage from './BlogSinglePage';
import GalleryPage from './GalleryPage';
import SocietyPage from './SocietyPage';
import TeamPage from './TeamPage';
import EditionPage from './EditionPage';
import GallerySinglePage from "./GallerySinglePage";
import SocietySinglePage from "./SocietiesSingleCategory";
import SocietySingleSingle from "./SocSingle";
import QuizPage from "./QuizPage"
import QuizSinglePage from "./QuizSinglePage";

export default {
    LandingPage, 
    AboutPage, 
    ContactPage, 
    BlogPage, 
    BlogSinglePage,
    GalleryPage,
    SocietyPage,
    TeamPage ,
    EditionPage,
    GallerySinglePage,
    SocietySinglePage,
    SocietySingleSingle,
    QuizPage,
    QuizSinglePage
}